/**
 * Pattern to split the first and only first hyphen
 */
const resourceNamePattern = /-(.*)/s

/**
 * @param id resource full id such as "servicename-resource"
 * Other scenarios are to be expected (Such as id '__internal__'), but are an exception
 */
export const mapResourceNames = (id: string): [serviceName: string | null, resourceNameOrFullId: string] => {
    const [first, second] = id.split(resourceNamePattern)

    if (first && second) {
        /**
         * Has both, expected scenario
         */
        return [first, second]
    }

    if (first && !second) {
        /**
         * No hyphen, or a hyphen without a follow-up resource name, unexpected scenario
         */
        return [null, first]
    }

    if (!first && second) {
        /**
         * No service id
         */
        return [null, second]
    }

    /**
     * Nothing, just fallback
     */
    return [null, id]
}

export const mapResourceName = (id: string): string => {
    const [, second] = mapResourceNames(id)

    return second
}
